<template>
	<section>
		<div class="border-2 rounded-lg border-neutral-800 bg-neutral-800">
			<div class="px-5 py-4">
				<h5 class="mb-0 font-medium leading-none text-white">
					{{ $t('personality-results.accordions.key-traits') }}
				</h5>
			</div>

			<div class="p-5 space-y-6 rounded-b-lg bg-neutral-900">
				<TopTraitsAccordion
					v-for="(trait, index) in traits"
					:key="index"
					:top-trait="trait"
					:wheel-mode="wheelMode"
				/>
			</div>
		</div>
	</section>
</template>

<script>
import TopTraitsAccordion from './TopTraitsAccordion.vue'

export default {
	name: 'OverviewKeyTraits',
	components: {
		TopTraitsAccordion
	},
	props: {
		traits: {
			type: Array,
			default: () => []
		},
		wheelMode: {
			type: String,
			required: true,
			validator: value =>
				['applicant', 'job', 'comparison'].includes(value)
		}
	}
}
</script>
